module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('VoteBase', {
    scopedSlots: _vm._u([{
      key: "voteMain",
      fn: function() {
        return [(_vm.data) ? _c('VoteForm', {
          attrs: {
            "formData": _vm.data,
            "func": _vm.funcType,
            "isUpdate": _vm.isUpdate
          },
          on: {
            "submitData": function($event) {
              return _vm.submitData($event)
            }
          }
        }) : _vm._e()]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-bef38dd0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/vote/VoteUpdate.vue
// module id = gRxv
// module chunks = 4